import SectionMixin from 'component/sections/base/section-mixin';
import { Component, componentMixin } from '@resn/gozer-core/component';
import { autobind } from 'core-decorators';
import { styleMap } from 'lit-html/directives/style-map.js';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import Copy from '@resn/gozer-core/copy';
import { html } from '@resn/gozer-core';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import './index.scss';
import svg from 'component/svg';
import env from 'core/env';
import config from '@resn/gozer-core/config';
// import Link from '@resn/gozer-core/router/link';
import { PAGE_DATA } from 'data/page-data';
import { Router } from '@resn/gozer-core/router';

import Analytics from '@resn/gozer-core/analytics';

const template = ({ context, props, options }) => html`
    <section
        class="cookieBar"
        style=${styleMap({
            display: props.visible ? 'flex' : 'none',
        })}
    >
        <div class="cookieBar__accept">
            <p class="cookieBar__acceptText" @click=${context.onAccept}>Accept</p>
            <div class="cookieBar__closeBtn" @click=${context.onAccept}>${svg('close', 'cookieBar__closeIcon')}</div>
        </div>
        <p class="cookieBar__text">
            <span class="cookieBar__title">${Copy.get('general-residual-cookiebar-title')}</span>

            ${unsafeHTML(
                Copy.get('general-residual-cookiebar', {
                    cookie: `<a href="${PAGE_DATA.COOKIEPOLICY.path}" target="_blank">${Copy.get(
                        'general-residual-cookiebar-cookie-text',
                    )}</a>`,
                    privacy: `<a href="${PAGE_DATA.PRIVACYPOLICY.path}" target="_blank">${Copy.get(
                        'general-residual-cookiebar-privacy-text',
                    )}</a>`,
                }),
            )}
        </p>
    </section>
`;

@componentMixin(DomComponentMixin)
@componentMixin(SectionMixin)
class CookieBar extends Component {
    props = {
        visible: false,
        acceptCookies: false,
    };

    options = {
        template,

        cookieLink: `${env.CDN}static/pdf/Cookie Policy.pdf`,
        privacyLink: `${env.CDN}static/pdf/Privacy Policy.pdf`,
    };

    async onSetup() {
        const acceptCookies = localStorage.getItem('user-accept-cookies');

        if (acceptCookies === null) {
            this.props.visible = true;
        } else {
            if (acceptCookies === 'true') {
                this.props.acceptCookies = true;
            }
        }
    }

    @autobind
    onAccept() {
        this.props.acceptCookies = true;

        this.allow();
    }

    allow() {
        localStorage.setItem('user-accept-cookies', true);

        this.props.visible = false;
        this.props.acceptCookies = true;
    }

    onAcceptCookies() {
        console.log('onAcceptCookies');
        Analytics.initialize({ gaID: config.gaID });
    }
}

export default CookieBar;
